import React, { useMemo } from 'react';
import _ from 'lodash';

const EnhancedPersonSelect = ({ 
  part,       // 身体部位 (hat, hair, clothing, skin, pants, shoes)
  attribute,  // 属性类型 (color, type, feature)
  value, 
  onChange, 
  className, 
  onClick, 
  disabled,
  options, 
  allResults,
  style
}) => {
  // 计算每个选项的匹配数量
  const optionsWithCount = useMemo(() => {
    if (!allResults || allResults.length === 0 || !options) {
      return options;
    }
    
    // 根据特征和属性统计数量
    const counts = {};
    
    // 遍历所有结果
    allResults.forEach(result => {
      if (!result.rawData || !result.rawData.features) return;
      
      const features = result.rawData.features;
      
      // 处理嵌套特征结构
      if (features[part] && typeof features[part] === 'object') {
        const feature = features[part][attribute];
        if (feature) {
          const featureValue = String(feature).toLowerCase();
          counts[featureValue] = (counts[featureValue] || 0) + 1;
        }
      }
      
      // 兼容处理原始特征格式
      const originalFeatures = result.rawData.original_features;
      if (originalFeatures) {
        let featureKey;
        if (part === 'skin' && attribute === 'feature') {
          featureKey = 'skin_feature';
        } else {
          featureKey = `${part}_${attribute}`;
        }
        
        const feature = originalFeatures[featureKey];
        if (feature) {
          const featureValue = String(feature).toLowerCase();
          counts[featureValue] = (counts[featureValue] || 0) + 1;
        }
      }
    });
    
    // 为选项添加计数
    return options.map(option => {
      if (option.value === 'none') {
        return option;
      }
      
      const count = counts[option.value.toLowerCase()] || 0;
      return {
        ...option,
        count,
        label: `${option.label} (${count})`
      };
    });
  }, [allResults, options, part, attribute]);
  
  return (
    <select
      value={value}
      onChange={onChange}
      className={className}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      {optionsWithCount.map(option => (
        <option 
          key={option.value} 
          value={option.value}
          style={{
            fontWeight: option.count > 0 ? 'bold' : 'normal',
            color: option.count > 0 ? '#000' : '#666'
          }}
        >
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default EnhancedPersonSelect;